// Silifke Sepeti: YouTube facade — tıklanana kadar gerçek video yüklenmez (performans)
document.addEventListener('click', function (e) {
  var facade = e.target.closest('[data-yt-facade]');
  if (!facade) return;
  loadYoutubeFacade(facade);
});
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter' && e.key !== ' ') return;
  var facade = e.target.closest('[data-yt-facade]');
  if (!facade) return;
  e.preventDefault();
  loadYoutubeFacade(facade);
});
function loadYoutubeFacade(facade) {
  var id = facade.dataset.ytId;
  var iframe = document.createElement('iframe');
  iframe.setAttribute('src', 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0');
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
  iframe.setAttribute('allowfullscreen', '');
  facade.replaceWith(iframe);
  iframe.className = 'yt-facade-iframe';
}
